import { api, TAGS } from "@/store/api"
import {
  IAssignQuickSlotReq,
  IClearQuickSlotReq,
  IDevDurabilityConsumeReq,
  IDevGrantReq,
  IDevMoveReq,
  IDevMutationResponse,
  IDevRemoveReq,
  IDevRepairReq,
  IDevStateWriteResponse,
  IDiscardReq,
  IDiscardResponse,
  IEquipReq,
  IEquipResponse,
  IInventoryView,
  IQuickSlotsResponse,
  IUnequipReq,
  IUnequipResponse,
  IUseConsumableReq,
  IUseConsumableResponse
} from "@/store/apis/inventoryAPI/inventory.types"

export const inventoryAPI = api
  .enhanceEndpoints({ addTagTypes: [TAGS.INVENTORY, TAGS.HERO] })
  .injectEndpoints({
    endpoints: (build) => ({
      getInventory: build.query<IInventoryView, void>({
        query: () => ({ url: "/inventory/me", method: "GET" }),
        providesTags: [TAGS.INVENTORY]
      }),
      equipItem: build.mutation<IEquipResponse, IEquipReq>({
        query: (data) => ({ url: "/inventory/equip", method: "POST", data }),
        invalidatesTags: [TAGS.INVENTORY, TAGS.HERO]
      }),
      unequipItem: build.mutation<IUnequipResponse, IUnequipReq>({
        query: (data) => ({ url: "/inventory/unequip", method: "POST", data }),
        invalidatesTags: [TAGS.INVENTORY, TAGS.HERO]
      }),
      discardItem: build.mutation<IDiscardResponse, IDiscardReq>({
        query: (data) => ({ url: "/inventory/discard", method: "POST", data }),
        invalidatesTags: [TAGS.INVENTORY]
      }),
      useConsumable: build.mutation<IUseConsumableResponse, IUseConsumableReq>({
        query: (data) => ({
          url: "/inventory/consumables/use",
          method: "POST",
          data
        }),
        invalidatesTags: [TAGS.INVENTORY, TAGS.HERO]
      }),
      assignQuickSlot: build.mutation<IQuickSlotsResponse, IAssignQuickSlotReq>(
        {
          query: (data) => ({
            url: "/inventory/consumable-slots/assign",
            method: "POST",
            data
          }),
          invalidatesTags: [TAGS.INVENTORY]
        }
      ),
      clearQuickSlot: build.mutation<IQuickSlotsResponse, IClearQuickSlotReq>({
        query: (data) => ({
          url: "/inventory/consumable-slots/clear",
          method: "POST",
          data
        }),
        invalidatesTags: [TAGS.INVENTORY]
      }),
      devGrant: build.mutation<IDevMutationResponse, IDevGrantReq>({
        query: (data) => ({
          url: "/inventory/dev/grant",
          method: "POST",
          data
        }),
        invalidatesTags: [TAGS.INVENTORY, TAGS.HERO]
      }),
      devRemove: build.mutation<IDevMutationResponse, IDevRemoveReq>({
        query: (data) => ({
          url: "/inventory/dev/remove",
          method: "POST",
          data
        }),
        invalidatesTags: [TAGS.INVENTORY, TAGS.HERO]
      }),
      devMove: build.mutation<IDevMutationResponse, IDevMoveReq>({
        query: (data) => ({ url: "/inventory/dev/move", method: "POST", data }),
        invalidatesTags: [TAGS.INVENTORY, TAGS.HERO]
      }),
      devDurabilityConsume: build.mutation<
        IDevStateWriteResponse,
        IDevDurabilityConsumeReq
      >({
        query: (data) => ({
          url: "/inventory/dev/durability-consume",
          method: "POST",
          data
        }),
        invalidatesTags: [TAGS.INVENTORY, TAGS.HERO]
      }),
      devRepair: build.mutation<IDevStateWriteResponse, IDevRepairReq>({
        query: (data) => ({
          url: "/inventory/dev/repair",
          method: "POST",
          data
        }),
        invalidatesTags: [TAGS.INVENTORY, TAGS.HERO]
      })
    })
  })

export const {
  useGetInventoryQuery,
  useEquipItemMutation,
  useUnequipItemMutation,
  useDiscardItemMutation,
  useUseConsumableMutation,
  useAssignQuickSlotMutation,
  useClearQuickSlotMutation,
  useDevGrantMutation,
  useDevRemoveMutation,
  useDevMoveMutation,
  useDevDurabilityConsumeMutation,
  useDevRepairMutation
} = inventoryAPI
